import React, { createContext, useReducer } from "react";
import AppReducer from "../reducer/appReducer";
// language file
import dutch from "../../languages/nl";

// Initial state
const initialState: any = {
  // Session data
  session: {},
  redirection: false,
  // language (default French)
  language: dutch,

};

// Create context
export const GlobalContext = createContext(initialState);

// Provider component
export const GlobalProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(AppReducer, initialState);
  return (
    <GlobalContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
